module.exports = __webpack_public_path__ + "img/1.082d17b0.jpg";